import { defineComponent as f, useSlots as h, openBlock as e, createElementBlock as i, createElementVNode as r, unref as l, renderSlot as m, createBlock as c, resolveDynamicComponent as y, toDisplayString as d, createCommentVNode as n, withCtx as u, createTextVNode as v } from "vue";
import g from "./ghl-ui.es199.js";
import "./ghl-ui.es23.js";
import "./ghl-ui.es326.js";
import p from "./ghl-ui.es72.js";
const C = { class: "hl-empty" }, S = {
  key: 1,
  class: "hl-empty-icon-container"
}, $ = { class: "hl-empty-icon" }, T = {
  key: 2,
  class: "hl-empty-title"
}, x = {
  key: 3,
  class: "hl-empty-description"
}, I = {
  key: 0,
  class: "hl-empty-actions"
}, B = {
  key: 1,
  class: "hl-empty-actions"
}, E = f({
  name: "UIEmpty",
  inheritAttrs: !1
}), w = f({
  ...E,
  props: {
    id: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    positiveText: {
      type: String,
      default: ""
    },
    icon: {
      type: Function,
      default: g
    },
    negativeText: {
      type: String,
      default: ""
    },
    positiveIcon: {
      type: Function,
      default: () => ""
    }
  },
  setup(t) {
    const a = h();
    return (o, s) => (e(), i("div", C, [
      r("div", null, [
        l(a).media ? m(o.$slots, "media", { key: 0 }) : (e(), i("div", S, [
          r("div", $, [
            (e(), c(y(t.icon), { class: "w-5 h-6" }))
          ])
        ])),
        t.title ? (e(), i("div", T, d(t.title), 1)) : n("", !0),
        t.description ? (e(), i("div", x, d(t.description), 1)) : n("", !0)
      ]),
      l(a).actions ? (e(), i("div", I, [
        m(o.$slots, "actions")
      ])) : (e(), i("div", B, [
        t.negativeText ? (e(), c(l(p), {
          key: 0,
          id: `${t.id}-btn-negative-action`,
          onClick: s[0] || (s[0] = (k) => o.$emit("negativeClick"))
        }, {
          default: u(() => [
            v(d(t.negativeText), 1)
          ]),
          _: 1
        }, 8, ["id"])) : n("", !0),
        t.positiveText ? (e(), c(l(p), {
          key: 1,
          id: `${t.id}-btn-positive-action`,
          type: "primary",
          onClick: s[1] || (s[1] = (k) => o.$emit("positiveClick"))
        }, {
          default: u(() => [
            t.positiveIcon ? (e(), c(y(t.positiveIcon), {
              key: 0,
              class: "w-5 h-6"
            })) : n("", !0),
            v(" " + d(t.positiveText), 1)
          ]),
          _: 1
        }, 8, ["id"])) : n("", !0)
      ]))
    ]));
  }
}), F = w;
export {
  F as default
};
